(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name createPairing.directive:searchPanel
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="createPairing">
     <file name="index.html">
     <search-panel></search-panel>
     </file>
     </example>
     *
     */
    angular
        .module('createPairing')
        .directive('searchPanelParing', searchPanel)
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	});

    function searchPanel(MessageService, $stateParams, EventManagerService) {
        return {
            restrict: 'EA',
            scope: {
                airportNames: '=',
                numberOfDays:'=',
                searchWithinTypes: '=',
                trainingPrograms: '=',
                programDetails: '=',
                crewBases: '=',
                airCraftTypes: '=',
                carriers: '=',
                carriersList: '=',
                options: '=',
                events:'=',
                selectedLength:'=',
                onSearchPanelOpen: '&',
                onSubmitAction: '&',
                paramBaseListSby:'=',
              trainingCategoryList: '=',
              trainingLocationsList: '=',
              crewTypeCodes: '='
            },
            templateUrl: 'create-pairing/directives/search-panel-paring-directive.tpl.html',
            replace: false,
            controllerAs: 'searchPanelParing',
            bindToController: true,
            controller: ['$scope', 'CreatePairing', 'CommonLogicService', function ($scope, CreatePairing, CommonLogicService) {
                var vm = this;
                var selectedEvent = null;
                vm.model = {
                    flight: {
                        fromDate: '',
                        toDate: null,
                        originList: [],
                        flightNumber: null,
                        noOfDays: {days: 1, description: '1 Day'},
                        startPosition: 1,
                        acModels: [],
                        pageSize: 60,
                        nonAssignedFlights:true,
                        partialAssignedFlights:false,
                        carriers:[],
                        crewTypeCodes: []
                    },
                    training: {
                        fromDate: '',
                        toDate: '',
                        //program:'',
                        //programDetail: '',
                        category: '',
                        carriers:[],
                        location: '',
                        nonAssigned: true,
                        startPosition: 1,
                        pageSize: 100
                    },
                    event: CreatePairing.searchPanelEvent(),
                    eventAirports:[]

                };
                vm.flightSearch = false;
                vm.trainingSearch = false,
                vm.eventSearch = false;
                vm.model.eventAirports = vm.airportNames;
                vm.model.flight.fromDate = moment().format("DD/MM/YYYY");
                vm.model.training.fromDate = moment().format("DD/MM/YYYY");
                vm.model.event.fromDate.value = moment().format("DD/MM/YYYY");
                vm.model.event.toDate.value = moment().format("DD/MM/YYYY");
                vm.onSearchPanelClick = function (e, type) {
                    angular.forEach(CreatePairing.seachActions, function (flag) {
                        if (type === flag) {
                            vm[flag] = !vm[flag];
                            var options = {
                                searchType: type
                            };
                            vm.onSearchPanelOpen(options);
                        } else {
                            vm[flag] = false;
                        }
                    });
                };

                if ($stateParams.mode == "") {
                	vm.onSearchPanelClick(undefined, "flightSearch");
                }

              EventManagerService.registerEventListener(EventManagerService.EVENT.PANEL_CLOSE, notifyPanelClose);

                vm.panelClose = function(){
                    vm.flightSearch = false;
                    vm.trainingSearch = false;
                    vm.eventSearch = false;
                };

                vm.onAirportChange = function () {
                  vm.model.flight.noOfDays = {days: 1, description: '1 Day'};
                }

                function notifyPanelClose() {
                  vm.flightSearch = false;
                  vm.trainingSearch = false;
                  vm.eventSearch = false;
                }

                vm.actionButtonClick = function () {
                    var sendDataModel = null, actionText = '';
                    if (vm.flightSearch) {
                        if (validate('flightSearch')){
                            sendDataModel = vm.model.flight;
                            actionText = 'flightSearch';
                        }
                    }
                    if (vm.trainingSearch) {
                        if (validate('trainingSearch')) {
                            sendDataModel = vm.model.training;
                            actionText = 'trainingSearch';
                        }
                    }
                    if (vm.eventSearch) {
                        if (validate('eventSearch')) {
                            sendDataModel = vm.model.event;
                            actionText = 'eventSearch';
                        }
                    }
                    var options = {
                        action: actionText,
                        panelAction: vm.panelClose,
                        dataModel: sendDataModel
                    };
                    vm.onSubmitAction(options);
                };

                vm.onChangeEvent = function(item, model, label, event){
                    changeOnEvent(item);
                };

                vm.changeDateTime = function(flag){

                    var foD = moment(vm.model.event.fromDate.value, 'DD/MM/YYYY');
                    var eoD = moment(vm.model.event.toDate.value, 'DD/MM/YYYY');

                    if ('fromDate' == flag) {
                        if (vm.model.event.toDate.value===""  || eoD.diff(foD)<0){
                            vm.model.event.toDate.value = vm.model.event.fromDate.value;
                        }

                    }

                    var fD = moment(vm.model.event.fromDate.value + ' ' + vm.model.event.startTime.value, 'DD/MM/YYYY HH:mm');
                    var eD = moment(vm.model.event.toDate.value + ' ' + vm.model.event.endTime.value, 'DD/MM/YYYY HH:mm');
                    if (eD.diff(fD) < 0 && 'endTime' == flag) {
                        MessageService.error("Event times are incorrect!");
                    }

                    var selectedEvent = vm.model.event.selectedEvent !== undefined ? {} : vm.model.event.selectedEvent,
                        percentage = 100;
                    if (selectedEvent.dutyHrsCalculated) {
                        percentage = selectedEvent.dutyHrsPercent;
                    }

                    vm.model.event.duration.value = CommonLogicService.calculateDutyHours(vm.model.event.fromDate.value,
                        vm.model.event.startTime.value, vm.model.event.toDate.value, vm.model.event.endTime.value, percentage);
                    vm.model.event.duration.disabled = true;
                };

                function changeOnEvent(item){
                    selectedEvent = item;
                    vm.model.event.startTime.disabled = false;
                    vm.model.event.endTime.disabled = false;
                    vm.model.event.endTime.value=selectedEvent.endTime==null?'':selectedEvent.endTime;
                    vm.model.event.startTime.value=selectedEvent.startTime==null?'':selectedEvent.startTime;
                    vm.model.eventAirports = vm.airportNames;

                    if(selectedEvent.eventCategoryCode.toUpperCase() === 'DUTY'){
                        vm.model.event.excludeFromPayment.disabled=false;
                    }else{
                        vm.model.event.excludeFromPayment.disabled=true;
                    }
                    if(selectedEvent.eventCode.toUpperCase() === 'SBY' || selectedEvent.eventCode.toUpperCase() === 'ASBY'){
                        vm.model.event.airportStandBy.disabled=false;
                        vm.model.eventAirports = (vm.selectedLength === 0 && vm.paramBaseListSby)?
                        		vm.crewBases:vm.airportNames;
                    }else{
                        vm.model.event.airportStandBy.disabled=true;
                    }
                    if(selectedEvent.eventCode.toUpperCase() === 'OFF'){
                        vm.model.event.outStationOFF.disabled=false;
                        vm.model.event.startTime.value = ""
                        vm.model.event.startTime.disabled = true;
                        vm.model.event.endTime.value = ""
                        vm.model.event.endTime.disabled = true;
                    }else{
                        vm.model.event.outStationOFF.disabled=true;
                        vm.model.event.startTime.disabled = false;
                        vm.model.event.endTime.disabled = false;
                    }
                    if(selectedEvent.acTypeRequired){
                        vm.model.event.aircraftType.disabled = false;
                        vm.model.event.aircraftType.value = selectedEvent.aircraftType.aircraftType;
                    }else{
                        vm.model.event.aircraftType.value = '';
                        vm.model.event.aircraftType.disabled = true;
                    }

                    //Start location and end location
                    if(selectedEvent.startLocRequired ||selectedEvent.eventCode.toUpperCase() === 'OFF'){
                        vm.model.event.startLocation.disabled = false;
                        vm.model.event.startLocation.value = selectedEvent.startLocation;
                    }else{
                        vm.model.event.startLocation.disabled = true;
                        vm.model.event.startLocation.value = '';
                    }
                    if(selectedEvent.endLocRequired || selectedEvent.eventCode.toUpperCase() === 'OFF'){
                        vm.model.event.endLocation.disabled = false;
                        vm.model.event.endLocation.value = selectedEvent.endLocation;
                    }else{
                        vm.model.event.endLocation.disabled = true;
                        vm.model.event.endLocation.value = '';
                    }
                }

                function validate(type){
                    if (type==='flightSearch'){
                        if (vm.model.flight.fromDate == ""){
                            MessageService.error("Departure date is required!");
                            return false;
                        }else if(vm.model.flight.noOfDays == undefined){
                            MessageService.error("Number of days is required!");
                            return false;
                        }
                    }
                    if (type==='trainingSearch'){
                        if (vm.model.training.from == ""){
                            MessageService.error("Departure date is required!");
                            return false;
                        }
                    }
                    if (type==='eventSearch'){
                        var fD = moment(vm.model.event.fromDate.value + ' ' + vm.model.event.startTime.value, 'DD/MM/YYYY HH:mm');
                        var eD = moment(vm.model.event.toDate.value + ' ' + vm.model.event.endTime.value, 'DD/MM/YYYY HH:mm');
                        if (selectedEvent == null || $.trim(selectedEvent)==""){
                            MessageService.error("Event is required!");
                            return false;
                        }else if(vm.model.event.fromDate.value == ""){
                            MessageService.error("From date is required!");
                            return false;
                        }else if(vm.model.event.toDate.value == ""){
                            MessageService.error("To date is required!");
                            return false;
                        }else if (eD.diff(fD) < 0) {
                            MessageService.error("Event times are incorrect!");
                            return false;
                        }else if ((selectedEvent.startLocRequired ||  selectedEvent.eventCode.toUpperCase() === 'OFF') && $.trim(vm.model.event.startLocation.value) == "") {
                            MessageService.error("Start location required!");
                            return false;
                        }else if ((selectedEvent.endLocRequired ||  selectedEvent.eventCode.toUpperCase() === 'OFF')  && $.trim(vm.model.event.endLocation.value) == "") {
                            MessageService.error("End location required!");
                            return false;
                        }else if (selectedEvent.acTypeRequired && $.trim(vm.model.event.aircraftType.value) == "") {
                          MessageService.error("A/C Type required!");
                          return false;
                        }

                    }
                    return true;
                }


            }],
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
            }
        };
    }
}());
